import { render, staticRenderFns } from "./HotSearches.vue?vue&type=template&id=37200b79&scoped=true&"
import script from "./HotSearches.vue?vue&type=script&lang=js&"
export * from "./HotSearches.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37200b79",
  null
  
)

export default component.exports